/**
 * @generated SignedSource<<b017ceb17131c5218df44a77f1705c11>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FiltersForCompetitionApprovalsFragment$data = {
  readonly viewerCanApprove: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"CompetitionStageSelectFragment">;
  readonly " $fragmentType": "FiltersForCompetitionApprovalsFragment";
};
export type FiltersForCompetitionApprovalsFragment$key = {
  readonly " $data"?: FiltersForCompetitionApprovalsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FiltersForCompetitionApprovalsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FiltersForCompetitionApprovalsFragment",
  "selections": [
    {
      "alias": "viewerCanApprove",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "CREATE_PROJECT_VERSION_APPROVAL"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"CREATE_PROJECT_VERSION_APPROVAL\")"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "requiresApproval",
          "value": true
        }
      ],
      "kind": "FragmentSpread",
      "name": "CompetitionStageSelectFragment"
    }
  ],
  "type": "Competition",
  "abstractKey": null
};

(node as any).hash = "127c35ce3e7f3e75bba878ec341c86d9";

export default node;
